export const UPLOAD_CATALOG_STEPS = ['Subir plantilla', 'Resumen'];

export const UPLOAD_CATALOGUE_MODAL_TEXT = {
  description:
    'Estás por realizar un reemplazo del catálogo, solo quedarán prendidos los productos que estás cargando. ¿Seguro que deseas continuar?',
  firstButtonText: 'No, cancelar',
  secondButtonText: 'Sí, reemplazar catálogo'
};
